import Route404 from './404';
import LockScreen from './lockScreen';

export {
	Route404,
	LockScreen
}



// WEBPACK FOOTER //
// ./src/browser/components/app/index.js